import { useState, ReactNode } from 'react';
import '../../../../styles/kanbans/ai-tools/ai-collapse.css';

interface AICollapseProps {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
}

export default function AICollapse({ 
  title, 
  children, 
  defaultExpanded = true 
}: AICollapseProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <div className="ai-collapse">
      <button 
        className="ai-collapse__header"
        onClick={toggleExpanded}
        type="button"
        aria-expanded={isExpanded}
      >
        <span className="ai-collapse__arrow">
          {isExpanded ? '▲' : '▼'}
        </span>
        <span className="ai-collapse__title">{title}</span>
      </button>
      
      {isExpanded && (
        <div className="ai-collapse__content">
          {children}
        </div>
      )}
    </div>
  );
}

